import { Injectable } from "@angular/core";
import { BeaconHandlerService } from "../handlers/beacon-handler.service";
import { BeaconDTO } from "./Beacon";

@Injectable({
  providedIn: "root",
})
export class BeaconService {
  constructor(private BeaconHandlerService: BeaconHandlerService) {}

  //LIST
  getBeacons(
    masterAccountID: number,
    queryParams?: {
      page?: number;
      perPage?: number;
      facility_floor_id?: number | null;
    },
  ) {
    return this.BeaconHandlerService.getBeacons(masterAccountID, queryParams);
  }

  getBeacon(masterAccountID: number, beaconID: number) {
    return this.BeaconHandlerService.getBeacon(masterAccountID, beaconID);
  }

  deleteBeacon(accountMasterID: number, beaconID: number) {
    return this.BeaconHandlerService.deleteBeacon(accountMasterID, beaconID);
  }

  createBeacon(accountMasterID: number, beaconDTO: BeaconDTO) {
    const copy = { ...beaconDTO };
    copy.facilityFloor = undefined;
    return this.BeaconHandlerService.postBeacon(accountMasterID, copy);
  }

  updateBeacon(accountMasterID: number, beaconDTO: BeaconDTO) {
    const copy = { ...beaconDTO };
    copy.facilityFloor = undefined;
    return this.BeaconHandlerService.putBeacon(accountMasterID, copy);
  }
}
